import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Backdrop,
  Container,
  CircularProgress,
  Typography,
} from '@mui/material';
import 'react-datepicker/dist/react-datepicker.css';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

import { useUserAuth } from '../../context/UserAuthContext';
import { useSearch } from '../../context/SearchContext';

import Header from '../../components/Header/Header';
import Logo from '../../components/Logo/Logo';
import Content from './Content/Content';

import './ClientReporting.css';

const Main = () => {
  const { selectedOloStore, setSelectedOloStore } = useSearch();
  const navigate = useNavigate();

  const { user: firebaseUser, loading: authenticating } = useUserAuth();

  const [loading, setLoading] = useState(true);
  const [stores, setStores] = useState([]);
  const [showAlert, setShowAlert] = useState('');

  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    cell: '',
    role: '',
    defaultStore: '',
    storeName: '',
    department: '', // This field is only visible when the role is 'Basecamp'
  });
  useEffect(() => {
    if (firebaseUser.getIdToken) {
      handleGetStores();
      handleGetUserInfo();
    }
  }, [firebaseUser]);

  const handleGetUserInfo = async () => {
    try {
      setLoading(true);
      const firebaseUserIdToken = await firebaseUser.getIdToken(true);
      const response = await axios.get(
        `/hd-api/user/${firebaseUser.email}/info`,
        {
          headers: {
            Authorization: `Bearer ${firebaseUserIdToken}`,
          },
          'Content-Type': 'application/json',
        }
      );
      if (response.data.newUser) {
        navigate('/profile');
      } else {
        setFormData({
          ...response.data.userInfo,
        });
        if (response.data.userInfo.role.toLowerCase() === 'direct') {
          // if the direct user has a store, load their default store
          if (response.data.userInfo.selectedStore) {
            setSelectedOloStore(response.data.userInfo.selectedStore);
          } else {
            setSelectedOloStore('all');
          }
          // if the direct user does not have a store, load all stores
          // and let them see the button selector
        } else if (
          response.data.userInfo.role.toLowerCase() === 'store' &&
          response.data.userInfo.defaultStore
        ) {
          setSelectedOloStore(response.data.userInfo.defaultStore);
        } else if (
          response.data.userInfo.role.toLowerCase() === 'basecamp' &&
          !selectedOloStore
        ) {
          setSelectedOloStore('all');
        } else if (
          response.data.userInfo.role.toLowerCase() === 'do' &&
          !selectedOloStore
        ) {
          setSelectedOloStore('all');
        }
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching user info from db:', error);
      setLoading(false);
    }
  };

  const handleGetStores = async () => {
    try {
      setLoading(true);
      const firebaseUserIdToken = await firebaseUser.getIdToken(true);
      const response = await axios.get(
        `/hd-api/user/stores/${firebaseUser.email}`,
        {
          headers: {
            Authorization: `Bearer ${firebaseUserIdToken}`,
          },
          'Content-Type': 'application/json',
        }
      );
      const updatedStores = response.data.stores;
      updatedStores.unshift({ storeId: 'all', storeName: 'All' });
      setStores(response.data.stores);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching stores from db:', error);
      setLoading(false);
    }
  };

  const { role } = formData;

  let content;
  if (authenticating) {
    content = (
      <div style={{ marginTop: '10%', width: '100%', textAlign: 'center' }}>
        <CircularProgress />
      </div>
    );
  } else {
    content = (
      <div style={{ textAlign: 'center', marginTop: 16 }}>
        <Typography style={{ fontFamily: 'Lato', fontSize: 34 }}>
          Client Reporting
        </Typography>
        <Content
          firebaseUser={firebaseUser}
          formData={formData}
          role={role}
          stores={stores}
          selectedOloStore={selectedOloStore}
          setSelectedOloStore={setSelectedOloStore}
        />
      </div>
    );
  }

  return (
    <div>
      <Header isTabletOrMobile={isTabletOrMobile} />
      <Container maxWidth='xl'>
        <Logo isTabletOrMobile={isTabletOrMobile} showAlert={showAlert} />
        {content}
      </Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  );
};

export default Main;
